import React from 'react';
import { DataTableColumnMeta } from './types';
import { DefaultDataCellSkeleton } from '@/components/ui/DataCell/DataCell';
import { DataCellSkeletons } from '@/components/ui/DataCell/DataCellSkeletons';

interface DataTableSkeletonCellProps {
  columnId: string;
  meta?: DataTableColumnMeta;
}

/**
 * Generates appropriate skeleton cell based on cell variant type
 * Uses skeleton from the cell component if available, otherwise uses default
 */
export function DataTableSkeletonCell({
  columnId,
  meta,
}: DataTableSkeletonCellProps) {
  void columnId;
  const cellMeta = meta?.cell;
  const variant = cellMeta?.variant;

  // Get skeleton component from DataCellSkeletons map
  if (variant && variant in DataCellSkeletons) {
    const SkeletonComponent =
      DataCellSkeletons[variant as keyof typeof DataCellSkeletons];
    if (SkeletonComponent) {
      return <SkeletonComponent />;
    }
  }

  // Fallback to default skeleton
  return <DefaultDataCellSkeleton />;
}

